<template>
  <div v-if="loading" class="d-flex align-center justify-center" style="padding-top: 15px">
    <v-progress-circular indeterminate="indeterminate" color="primary" size="48"></v-progress-circular>
  </div>
  <v-layout v-else-if="noData && !loading" style="height: calc(100vh - 100px)">
    <v-layout column justify-center align-center fill-height>
      <h1>{{ $t('Device not found') }}...</h1>
      <v-btn color="#292F7D" class="mt-4 subheading" dark round @click="$router.push('/fullViewReport')">{{ $t('Back To Home Page') }}</v-btn>
    </v-layout>
  </v-layout>
  <v-layout v-else class="cabinet-details-screen pa-4" column>
    <v-layout row wrap align-center>
      <v-flex shrink>
        <v-icon medium @click="goBack" color="black">{{ lang === 'en' ? 'mdi-arrow-left' : 'mdi-arrow-right'}}</v-icon>
      </v-flex>
      <v-flex grow>
        <v-layout justify-center align-center>
          <span v-if="cabinetData.description" class="title font-weight-bold" :class="lang === 'en' ? 'ml-2' : 'mr-2'">{{ `${$t('Cabinet')} ${$t(cabinetData.id)} ${cabinetData.description}` }}</span>      
          <span v-else class="title font-weight-bold" :class="lang === 'en' ? 'ml-2' : 'mr-2'">{{ `${$t('Cabinet ID')}: ${$t(cabinetData.id)}` }}</span>      
          <span v-if="cabinetData.cabinet_type" class="property-name subheading font-weight-bold mx-3">{{ $t(cabinetData.cabinet_type) }} </span>          
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout justify-space-between row wrap align-center class="mt-3">
      <v-flex shrink d-flex xs12 style="overflow-x: auto">
        <v-card class="tabs-cabinet-details" style="background-color: white !important">
          <div :key="tab.value" v-for="tab in tabs" @click="setSelectedTab(tab.value)" :class="['tab-cabinet-details', selectedTab === tab.value ? 'selected-tab-cabinet-details' : '']">
            {{ $t(tab.title) }}
          </div>
        </v-card>
      </v-flex>
      <v-flex shrink d-flex xs12 style="overflow-x: auto">
        <v-layout class="mt-2" row wrap>
          <v-flex shrink>
            <v-layout row wrap align-center>
              <v-tooltip v-if="display_connection_state" bottom style="z-index: 5">
                <v-layout row wrap slot="activator" align-center>
                  <v-img contain :src="getStreamStatus('sys___connected')" height="18" width="18"></v-img>
                  <span class="property-name subheading font-weight-medium mx-2">{{ device && device.sys___connected ? $t('Connected') : $t('Disconnected') }}</span>
                </v-layout>
                <span>{{ connection_state }}</span>
              </v-tooltip>
              <template v-if="services_config_status.display_alerts_service">
                <v-divider v-if="display_connection_state" vertical :class="lang === 'en' ? 'mr-2' : 'ml-2'" style="border-width: 1px;"></v-divider>
                <v-tooltip bottom style="z-index: 5">
                  <v-layout row wrap slot="activator" align-center>
                    <v-img contain :src="getAlertServiceStatus" height="18" width="18"></v-img>
                    <span class="property-name subheading font-weight-medium mx-2">{{ $t('Alerts Service') }}</span>
                  </v-layout>
                  <span v-if="services_config_status.alert_is_on">
                    {{ $t('Alerts Service is ON')}}
                  </span>
                  <span v-else>
                    {{ $t('Alerts Service is OFF') }}
                  </span>
                </v-tooltip>
              </template>
              <template v-if="!cabinetData.cabinet_type && services_config_status.display_cabinet_iq_service">
                <v-divider vertical :class="lang === 'en' ? 'mr-2' : 'ml-2'" style="border-width: 1px;"></v-divider>
                <v-img contain :src="getCabinetAlertServiceStatus" height="18" width="18"></v-img>
                <v-tooltip bottom style="z-index: 5">
                  <span
                    slot="activator" 
                    class="property-name subheading font-weight-medium"
                    :class="schedule_service.exist && schedule_service.active ? 'mx-2' : lang === 'en' ? 'ml-2' : 'mr-2'"
                  >
                    {{ $t('Cabinet IQ Alerts') }}
                  </span>
                  <span>{{ $t('Critical Alerts Service') }}</span>
                </v-tooltip>
              </template>
              <template v-if="schedule_service.exist && schedule_service.active">
                <v-divider vertical :class="lang === 'en' ? 'mr-2' : 'ml-2'" style="border-width: 1px;"></v-divider>
                <v-tooltip bottom style="z-index: 5">
                  <v-layout row wrap slot="activator" align-center>
                    <v-img contain :src="getCabinetScheduleStatus" height="18" width="18"></v-img>
                    <span class="property-name subheading font-weight-medium mx-2">{{ $t('On') }}:</span>
                    <span class="property-name subheading font-weight-bold">{{ schedule_service.start_time }}</span>
                    <span class="property-name subheading font-weight-medium mx-2">{{ $t('Off') }}:</span>
                    <span class="property-name subheading font-weight-bold">{{ schedule_service.end_time }}</span>
                  </v-layout>
                  <span v-if="schedule_service.is_astronomical">{{ `${$t('Devices astronomical updater')} ${schedule_service.updater}` }}</span>
                  <span v-else>{{ `${$t('Devices schedule updater')} ${schedule_service.updater}` }}</span>
                </v-tooltip>
              </template>
              <template v-if="cabinetData.installation_date !== 'none'">
                <v-divider vertical class="mx-2" style="border-width: 1px;"></v-divider>
                <v-tooltip bottom style="z-index: 5">
                  <span slot="activator" class="property-name subheading font-weight-bold">
                    {{ `${$t('Installation Date')} ${cabinetData.installation_date}` }}
                  </span>
                  <span>{{ cabinetData.installater === 'none' ? $t('No installer details') : `${$t('Installed by')} ${cabinetData.installater}` }}</span>
                </v-tooltip>
              </template>
              <template>
                <v-divider vertical class="mx-2" style="border-width: 1px;"></v-divider>
                <v-tooltip bottom style="z-index: 5">
                  <v-layout row wrap slot="activator" align-center>
                    <v-img v-if="services_config_status.partial_day" slot="activator" :class="lang === 'en' ? 'mr-2' : 'ml-2'" contain :src="require('@/assets/images/cabinet_details_icons/partial_day_icon.png')" height="20" width="20"></v-img>
                    <v-img v-else slot="activator" :class="lang === 'en' ? 'mr-2' : 'ml-2'" contain :src="require('@/assets/images/cabinet_details_icons/all_day_icon.png')" height="20" width="20"></v-img>
                    <span v-if="services_config_status.partial_day" class="property-name subheading font-weight-bold">{{ $t('Cabinet operates') + ' ' + time_window }}</span>
                    <span v-else class="property-name subheading font-weight-bold">{{ $t('Cabinet operates') + ' 24/7' }}</span>
                  </v-layout>
                  <span>{{ $t('Operation Window') }}</span>
                </v-tooltip>
              </template>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="blue-rounded-card pa-3 my-2">
      <v-flex xs12 xl5 class="mb-2">
        <v-layout row wrap align-center>
          <img src="@/assets/images/cabinet_details_icons/cabinet.png" alt="" style="max-width: 20px" />
          <span :class="[lang === 'en' ? 'ml-1' : 'mr-1', 'subheading', 'font-weight-bold']">{{ device && device.name }}</span>
          <!-- Pushes the state badge to the far end of the name row, away from the name. -->
          <v-spacer></v-spacer>
          <v-tooltip v-if="operation_state" bottom style="z-index: 5">
            <span
              slot="activator"
              class="operation-state-badge"
              :class="[
                operation_state_badge_class,
                lang === 'en' ? 'ml-2 operation-state-badge--gap-ltr' : 'mr-2 operation-state-badge--gap-rtl'
              ]"
            >
              <v-img
                contain
                :class="lang === 'en' ? 'mr-2' : 'ml-2'"
                :src="require('@/assets/images/cabinet_details_icons/operation_state.png')"
                height="18"
                width="18"
              ></v-img>
              {{ operation_state }}
            </span>
            <span>{{ $t('Operation State') }}</span>
          </v-tooltip>
        </v-layout>
        <v-layout row wrap class="mt-3">
          <v-flex xs12 sm7>
            <v-layout>
              <v-flex xs4>
                <v-layout column>
                  <span class="property-name body-2">{{ $t('Address') }}</span>
                  <span class="property-name body-2">{{ $t('Managed Area') }}</span>            
                </v-layout>
              </v-flex>
              <v-flex xs8>
                <v-layout column>
                  <span class="body-2 font-weight-bold overflow-style"><span>{{ $t(cabinetData.address) }}</span></span>
                  <span class="body-2 font-weight-bold overflow-style">{{ cabinetData.managed_area !== 'N/A' ? cabinetData.managed_area : $t(cabinetData.road) }}</span>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm5>
            <v-layout>
              <v-layout column>
                <span class="property-name body-2">{{ $t('Incidents') }}</span>
                <span class="property-name body-2">{{ $t('Connected And Active') }}</span>
              </v-layout>
              <v-layout column>
                <v-layout row align-center>
                  <v-tooltip top style="z-index: 5">
                    <v-layout row wrap slot="activator" align-center>
                      <div class="red_alert square_alert"></div>
                      <span class="body-2 font-weight-bold overflow-style mx-1">{{ incidents_data.high }}</span>
                    </v-layout>
                    <span>{{ $t('High Priority') }}</span>
                  </v-tooltip>
                  <v-tooltip top style="z-index: 5">
                    <v-layout row wrap slot="activator" align-center>
                      <div class="yellow_alert square_alert" :class="lang === 'en' ? 'ml-1' : 'mr-1'"></div>
                      <span class="body-2 font-weight-bold overflow-style mx-1">{{ incidents_data.mid }}</span>
                    </v-layout>
                    <span>{{ $t('Medium Priority') }}</span>
                  </v-tooltip>
                  <v-tooltip top style="z-index: 5">
                    <v-layout row wrap slot="activator" align-center>
                      <div class="green_alert square_alert" :class="lang === 'en' ? 'ml-1' : 'mr-1'"></div>
                      <span class="body-2 font-weight-bold overflow-style mx-1">{{ incidents_data.low }}</span>
                    </v-layout>
                    <span>{{ $t('Low Priority') }}</span>
                  </v-tooltip>
                  <v-tooltip top style="z-index: 5">
                    <v-layout row wrap slot="activator" align-center>
                      <div class="info_alert square_alert" :class="lang === 'en' ? 'ml-1' : 'mr-1'"></div>
                      <span class="body-2 font-weight-bold overflow-style mx-1">{{ events_list.length }}</span>
                    </v-layout>
                    <span>{{ $t('Info') }}</span>
                  </v-tooltip>
                </v-layout>
                <div v-if="loading_project_devices">
                  <v-progress-circular indeterminate="indeterminate" color="primary"></v-progress-circular>
                </div>
                <v-layout v-else row align-center>
                  <span
                    class="body-2 font-weight-bold overflow-style"
                    :class="cabinetData.connected_fixtures_percentage < 60 ? 'red--text' : cabinetData.connected_fixtures_percentage > 89 ? 'green--text' : 'orange--text'"
                  >
                    {{ `${cabinetData.connected_fixtures_percentage}%` }}
                  </span>
                  <v-tooltip v-if="cabinetData.retrofit_fixtures_count" top style="z-index: 5">
                    <v-icon slot="activator" size="16" color="#8a90b3" :class="lang === 'en' ? 'ml-1' : 'mr-1'">mdi-information-outline</v-icon>
                    <span>{{ retrofitTooltipText }}</span>
                  </v-tooltip>
                </v-layout>
              </v-layout>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 xl7>
        <v-layout column>
          <v-layout row wrap class="mt-2">
            <v-layout>
              <v-flex shrink><v-divider vertical light></v-divider></v-flex>
              <v-flex class="px-3">
                <span class="subheading font-weight-bold property-name">{{ $t('Fixtures') }}</span>
                <v-layout class="mt-2">
                  <v-layout column>
                    <span class="body-2 font-weight-bold overflow-style">{{ cabinetData.assigned_devices }}</span>
                    <span class="property-name body-2">{{ $t('Total') }}</span>
                  </v-layout>
                  <v-layout column>
                    <span class="body-2 font-weight-bold overflow-style">{{ cabinetData.controlled_devices }}</span>
                    <span class="property-name body-2">{{ $t('Controlled') }}</span>
                  </v-layout>
                  <v-layout column>
                    <div v-if="loading_project_devices">
                  <v-progress-circular indeterminate="indeterminate" color="primary" size="20"></v-progress-circular>
                </div>
                    <span v-else class="body-2 font-weight-bold overflow-style">{{ cabinetData.actual_controlled_devices }}</span>
                    <span class="property-name body-2">{{ $t('Actual controlled') }}</span>
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex shrink><v-divider vertical light></v-divider></v-flex>
              <v-flex class="px-3">
                <span class="subheading font-weight-bold property-name">{{ $t('Poles') }}</span>
                <v-layout class="mt-2">
                  <v-layout column>
                    <span class="body-2 font-weight-bold overflow-style">{{ cabinetData.total_poles }}</span>
                    <span class="property-name body-2">{{ $t('Total') }}</span>
                  </v-layout>
                  <v-layout column>
                    <span class="body-2 font-weight-bold overflow-style">{{ cabinetData.controlled_poles }}</span>
                    <span class="property-name body-2">{{ $t('Controlled') }}</span>
                  </v-layout>
                  <v-layout column>
                    <div v-if="loading_project_devices">
                  <v-progress-circular indeterminate="indeterminate" color="primary" size="20"></v-progress-circular>
                </div>
                    <span v-else class="body-2 font-weight-bold overflow-style">{{ cabinetData.actual_controlled_poles }}</span>
                    <span class="property-name body-2">{{ $t('Actual controlled') }}</span>
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex shrink><v-divider vertical light></v-divider></v-flex>
              <v-flex class="px-3">
                <span class="subheading font-weight-bold property-name">{{ $t('Communication') }}</span>
                <v-layout class="mt-2">
                  <v-layout column>
                    <div v-if="loading_project_devices">
                      <v-progress-circular indeterminate="indeterminate" color="primary" size="20"></v-progress-circular>
                    </div>
                    <span v-else class="body-2 font-weight-bold overflow-style">{{ cabinetData.communicated_count }}</span>
                    <span class="property-name body-2">{{ $t('Communicated') }}</span>
                  </v-layout>
                  <v-layout column>
                    <div v-if="loading_project_devices">
                      <v-progress-circular indeterminate="indeterminate" color="primary" size="20"></v-progress-circular>
                    </div>
                    <span v-else class="body-2 font-weight-bold overflow-style">{{ cabinetData.uncommunicated_count }}</span>
                    <span class="property-name body-2">{{ $t('Never') }}</span>
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
    <HubTabs
      v-if="selectedTab && device"
      :selectedTab="selectedTab"
      :device="device"
      :cabinetDevices="cabinetDevices"
      :phasesLiveData="phasesLiveData"
      :cabinetData="cabinetData"
      :services_config="services_config"
      :services_config_status="services_config_status"
      :updateServiceStatus="updateServiceStatus"
      :updateMetaDeviceFields="updateMetaDeviceFields"
      :deviceStreams="cabinetStreams"
      :setDeviceStreams="setCabinetStreams"
      :sys_active_modified="sys___active_modified"
      :connection_state="connection_state"
      :electricity_price_prop="electricity_price_prop"
      :incidents_data="incidents_data"
      :alerts_list="alerts_list"
      :events_list="events_list"
      @updateServicesConfig="updateServicesConfig"
      @phasesLiveDataChanged="setPhasesLiveData"
      @updateSchedule="updateScheduleData"
      @updateOperationState="updateOperationState"
      @updateTariffData="updateTariffData"
      @setOperationStateProp="syncOperationStateToStore"
      @setElectricityPriceProp="setElectricityPriceProp"
    />
    <PropEditor ref="propEditor" />
  </v-layout>
</template>

<script>
import HubTabs from '@/pages/mapView/components/MapTabs/devices/HubInfoTabs.vue';
import Utils from '@/modules/Utils';
import moment from 'moment-timezone';
import cloneDeep from 'lodash/cloneDeep';
import PropEditor from '@/components/PropEditor.vue';
import { Types } from '@/modules/API';
import {
  fetchCabinetHeader,
  fetchCabinetFixtures,
  formatModified,
  invalidateDeviceTabCache,
  isHeaderModifiedFresh,
  getHeaderModifiedSnapshot,
  primeHeaderModifiedSnapshot,
  isCabinetDetailFresh,
  primeCabinetDetailFetched
} from '@/views/services/cabinetDetailsApi';
import { CROSS_PAGE_CABINET_FIELDS } from '@/store/modules/Reports';
import { RETROFIT_STATE, PARTIAL_RETROFIT_STATE, DELIVERED_STATE } from '@/modules/retrofitActions';

export default {
  components: {
    HubTabs,
    PropEditor
  },
  name: 'CabinetDetails',
  data() {
    return {
      noData: false,
      selectedTab: 'full-view',
      all_tabs: [
        // {title: 'Overview', value: 'overview', virtual: false, regular: true}, 
        {title: 'Full View', value: 'full-view', virtual: true, regular: true, readonly: true}, 
        {title: 'Energy', value: 'energy', virtual: false, regular: true, readonly: true},
        {title: 'Monitor', value: 'monitor', virtual: false, regular: true, readonly: true},
        {title: 'Cabinet Details', value: 'cabinet-details', virtual: true, regular: true, readonly: true},
        {title: 'Connections', value: 'connections', virtual: false, regular: true, readonly: true},
        {title: 'Control', value: 'control', virtual: false, regular: true, readonly: true},
        {title: 'Advanced', value: 'advanced', virtual: true, regular: true, readonly: true},
        {title: 'Billing', value: 'billing', virtual: false, regular: true, readonly: true},
        {title: 'Billing', value: 'virtual-billing', virtual: true, regular: false, readonly: true},
        {title: 'Attached Files', value: 'files', virtual: true, regular: true, readonly: false},
        {title: 'Incidents', value: 'incidents', virtual: true, regular: true, readonly: true}
      ],
      tabs: [],
      cabinetStreams: [],
      cabinetData: {
        id: '',
        installation_date: '',
        address: '',
        road: '',
        managed_area: '',
        cabinet_type: '',
        assigned_devices: '',
        controlled_devices: '',
        actual_controlled_devices: 0,
        total_poles: '',
        controlled_poles: '',
        actual_controlled_poles: 0,
        uncommunicated_count: 0,
        communicated_count: 0,
        description: '',
        retrofit_fixtures_count: 0
      },
      electricity_price_prop: null,
      sys___active_modified: null,
      sys___connected_modified: null,
      loading: true,
      // No longer a local data field — see `device` computed below. Kept here
      // intentionally absent so Vue resolves `device` to the computed getter
      // bound to Reports.reportsList for live reactivity.
      phasesLiveData: [],
      services_config: {},
      services_config_status: {
        window: {start: '', end: ''},
        display_alerts_service: false,
        partial_day: false,
        enabled_turn_off: false,
        alert_is_on: false,
        display_schedule_service: false,
        schedule_is_on: false,
        display_cabinet_iq_service: false,
        cabinet_iq_is_on: false
      },
      schedule_service: {
        is_astronomical: false,
        updater: '',
        start_time: '',
        end_time: '',
        active: false,
        exist: false
      },
      alerts_list: [],
      events_list: [],
      incidents_data: { 
        high: 0,
        mid: 0,
        low: 0,
        cabinetNumber: '',
        supply: '',
        roadNumber: '',
        maxA: 60,
        devices: [] 
      },
      loading_project_devices: true
    };
  },
  async mounted() {
    this.loading = true;
    this.$store.commit('Global/setPageTitle', 'Cabinet Details');

    if (this.$route.params.pid) {
      this.setSelectedTab('incidents');
    }

    await this.fetchCabinetData();
    this.setIncidentsData();
    this.loading = false;

    // Cabinet-only counts (Controlled / Communicated / Connected) read from
    // `cabinetDevices`, which is the reactive `cabinets_fixtures` getter for
    // THIS cabinet. fetchCabinetData has already populated those rows in the
    // store, so there's nothing left to wait for from the project-wide stream.
    this.loading_project_devices = false;
  },
  beforeDestroy(){
    if (!this.$route.path.includes('cabinet-management')) {
      this.$store.commit('Global/setSelectedManagedArea', '');
    }
  },
  methods: {
    setIncidentsData(){
      this.setCabinetDataForIncidents();
      this.setCabinetAlertsList();
      this.setCabinetEventsList();
    },
    setCabinetDataForIncidents(){
      const current_cabinet = {...cloneDeep(this.device)};
      current_cabinet['services.config'] = current_cabinet['services.config'];
      if (current_cabinet['services.config'].hasOwnProperty('alerts')) {
        current_cabinet['meta.alert_config'] = current_cabinet['services.config'].alerts;
      }else current_cabinet['meta.alert_config'] = {};

      this.incidents_data = {...current_cabinet};
      this.incidents_data.maxA = (+current_cabinet['meta.alert_config'].max_a_phase_total || 60);
      this.incidents_data.cabinetNumber = this.cabinetData.id;
      this.incidents_data.supply = this.device['meta.device'][`iec's_supply_pole_id`] || 'N/A';
      this.incidents_data.roadNumber = this.device['meta.device'].managed_area || this.device['meta.device'].road || '';
      this.incidents_data.devices = this.$store.getters['Reports/cabinets_fixtures'].get(this.device.id);
    },
    async fetchCabinetData(){
      const device_id = this.$route.params.id || this.$route.params.cid || '';
      if (!device_id) {
        this.noData = true;
        return;
      }

      const companyId = this.$store.state.Reports.companyId
        || (this.project && this.project.company)
        || '';
      const projectId = this.$store.state.Reports.projectId
        || (this.project && this.project.id)
        || '';

      // TTL-aware fetch policy. If the global stream already populated this
      // cabinet's cross-page subset within the TTL window, only fetch the
      // small set of component-only display fields (sys___*__modified).
      // Otherwise, run the full header query and upsert the cross-page
      // subset into reportsList so the reactive `device` getter emits.
      // Fresh when EITHER the project-wide stream populated the cross-page
      // subset within TTL, OR this page ran its own on-demand fetch within TTL.
      // The second clause is what prevents a refetch on every re-entry when the
      // global stream hasn't (re)completed since our last visit.
      const fresh = this.$store.getters['Reports/cabinetCrossPageFresh'](device_id)
        || (!!this.device && isCabinetDetailFresh(device_id));
      // Virtual cabinets have no sys___active/sys___connected stream, so we
      // skip those columns. Best-effort: read class_name from the store row
      // if it's already there (e.g. user navigated from CabinetManagement).
      const isVirtual = !!(this.device && this.device.class_name === 'virtual_cabinet');

      // Skip the network entirely on a true cache hit — cross-page subset is
      // fresh AND we already have recent sys___*__modified values cached.
      // Virtual cabinets don't have sys___*__modified at all, so the second
      // freshness check is bypassed for them.
      const headerModifiedFresh = isVirtual || isHeaderModifiedFresh(device_id);
      const skipHeaderFetch = !!this.device && fresh && headerModifiedFresh;

      const fetchedHeader = skipHeaderFetch
        ? null
        : await fetchCabinetHeader({
            companyId,
            projectId,
            defaultLocation: this.$store.state.Props.project_default_location,
            id: device_id,
            fresh,
            isVirtual
          });

      if (!fetchedHeader && !this.device) {
        this.noData = true;
        return;
      }

      // Prime the header-modified cache from the freshly-fetched row so the
      // next quick re-entry skips the fetch. cabinet.operation_state applies
      // to virtual cabinets too (Retrofit/Partial Retrofit), so this isn't
      // gated on !isVirtual like the sys___*__modified fields are.
      if (fetchedHeader) {
        primeHeaderModifiedSnapshot(device_id, fetchedHeader);
      }

      // Mirror cross-page columns into the store. On TTL hit `fetchedHeader`
      // only carries sys___*__modified columns (not in CROSS_PAGE_CABINET_FIELDS),
      // so this is a no-op. On TTL miss we upsert the full cross-page subset.
      //
      // The location fields ride along on top of that subset for the same reason the
      // fixtures upsert below carries them: GMap's getInstalledWithValidLocation drops
      // any row without `has_valid_location`, so a cabinet row created here without them
      // gets no marker on the FullView map. The project-wide stream fills them in later,
      // but by then the map has already built its features, and a late `meta.location`
      // doesn't trigger marker creation (it isn't an icon-affecting field) - so the
      // cabinet stayed missing until the next page load happened to win the race.
      // fetchCabinetHeader requests meta.location and runs setDeviceCommonFields, which
      // derives has_valid_location / has_default_location, so the values are already here.
      if (fetchedHeader && !fresh) {
        this.$store.commit('Reports/upsertDeviceColumns', {
          device: fetchedHeader,
          columns: [
            ...CROSS_PAGE_CABINET_FIELDS,
            'name',
            'meta.location',
            'has_valid_location',
            'has_default_location'
          ]
        });
      }

      // Component-only display fields. Virtual cabinets don't have these
      // streams, so skip the formatting entirely.
      const isVirtualAfterFetch = isVirtual
        || !!(fetchedHeader && fetchedHeader.class_name === 'virtual_cabinet')
        || !!(this.device && this.device.class_name === 'virtual_cabinet');
      const cachedModified = getHeaderModifiedSnapshot(device_id);
      if (!isVirtualAfterFetch) {
        this.sys___active_modified = formatModified(
          (fetchedHeader && fetchedHeader['sys___active__modified'])
            || (cachedModified && cachedModified.sys___active__modified)
            || (this.device && this.device['sys___active__modified']),
          this.projectTimezone
        );
        this.sys___connected_modified = formatModified(
          (fetchedHeader && fetchedHeader['sys___connected__modified'])
            || (cachedModified && cachedModified.sys___connected__modified)
            || (this.device && this.device['sys___connected__modified']),
          this.projectTimezone
        );
      }

      // Schedule + operation_state arrive as columns on the header. The
      // `meta.devices_schedule` column is part of the cross-page subset
      // (now in store) and feeds setCurrentCabinetSchedule(); the
      // `cabinet.operation_state` is component-only but is needed by the
      // always-visible header, so it's part of HEADER_COLUMNS (eager fetch
      // above) and hydrated here. On a skip-fetch re-entry (fetchedHeader is
      // null) fall back to the cached snapshot, since a fresh component
      // instance otherwise loses it entirely until the Advanced tab is opened.
      // electricity.price still belongs to Advanced only.
      const cabinetOperationState = (fetchedHeader && fetchedHeader['cabinet.operation_state'])
        || (cachedModified && cachedModified['cabinet.operation_state']);
      if (cabinetOperationState !== undefined) {
        this.syncOperationStateToStore(cabinetOperationState);
      }

      // Fetch this cabinet's fixtures via reporting query and upsert the
      // cross-page subset for each so consumers (MapView, etc.) can pick
      // them up reactively. cabinetDevices computed getter reads from store.
      //
      // Skip on TTL hit — when the cross-page subset for this cabinet is
      // fresh, the global stream / earlier visit already populated the
      // store with this cabinet's fixtures. Refetching here is what made
      // the page-level spinner linger on a return visit.
      const cabinetHumanId = (fetchedHeader && fetchedHeader['meta.device']
        && fetchedHeader['meta.device'].cabinet_id)
        || (this.device && this.device['meta.device'] && this.device['meta.device'].cabinet_id)
        || '';
      if (cabinetHumanId && !fresh) {
        try {
          const fixtures = await fetchCabinetFixtures({
            companyId,
            projectId,
            defaultLocation: this.$store.state.Props.project_default_location,
            cabinetHumanId
          });
          fixtures.forEach((fixture) => {
            this.$store.commit('Reports/upsertDeviceColumns', {
              device: fixture,
              columns: [
                'id',
                'class_name',
                'sys___active',
                'sys___connected',
                'meta.category',
                'meta.commission',
                'meta.device',
                'meta.location',
                'name',
                'power',
                // Derived by setDeviceCommonFields in fetchCabinetFixtures.
                // Required by GMap's getInstalledWithValidLocation so the
                // FullView map can render these fixtures before the global
                // stream re-processes them.
                'has_valid_location',
                'has_default_location',
                // Icon-determining fields — without these computeIconKey throws
                // for disconnected fixtures and the marker renders gray.
                'device.schedule',
                'meta.schedule_curve',
                'disconnect_reason',
                // Retrofit state, so the marker paints as Retrofit on the first
                // render instead of flipping once the global stream arrives.
                'pole.operation_state'
              ]
            });
          });
        } catch (e) {
          // Non-fatal — cabinetDevices remains empty, page still renders.
        }
      }

      // Stamp the standalone-fetch TTL only when we actually hit the network
      // (i.e. this wasn't a cache hit). A fixed (non-sliding) window means the
      // data still refreshes every TTL even on frequent revisits.
      if (!fresh) primeCabinetDetailFetched(device_id);

      this.setCabinetData();
      await this.setCurrentCabinetSchedule();
    },
    async setCurrentCabinetSchedule(){
      // `meta.devices_schedule` is part of the cross-page subset and lives on
      // the store row (populated by either fetchCabinetHeader or the global
      // stream). Reading it here keeps a single source of truth.
      const cabinet_schedule = (this.device && this.device['meta.devices_schedule']) || null;

      // Reset first: this runs again whenever the schedule changes (see the
      // cabinetScheduleSignature watcher), so a schedule that was deactivated -
      // e.g. by marking the cabinet as Retrofit - has to clear the header chip
      // instead of leaving the previous snapshot in place.
      this.schedule_service.exist = false;
      this.schedule_service.active = false;
      this.schedule_service.is_astronomical = false;
      this.schedule_service.updater = '';
      this.schedule_service.start_time = '';
      this.schedule_service.end_time = '';

      if (cabinet_schedule && typeof cabinet_schedule === 'object' && Object.entries(cabinet_schedule).length){
        this.schedule_service.exist = true;
        this.schedule_service.active = cabinet_schedule.active;
        this.schedule_service.is_astronomical = cabinet_schedule.is_astronomical;
        this.schedule_service.updater = cabinet_schedule.updater;

        if (cabinet_schedule.is_astronomical){
          this.schedule_service.start_time = Utils.getAstronomicalTime(cabinet_schedule.dusk, this.dusk_dawn_data.dusk_timestamp, this.dusk_dawn_data.dusk, this.projectTimezone);
          this.schedule_service.end_time = Utils.getAstronomicalTime(cabinet_schedule.dawn, this.dusk_dawn_data.dawn_timestamp, this.dusk_dawn_data.dawn, this.projectTimezone);
        }else {
          this.schedule_service.start_time = Utils.convertUtcTimeToTimezone(cabinet_schedule.on, this.projectTimezone, 'HH:mm');
          this.schedule_service.end_time = Utils.convertUtcTimeToTimezone(cabinet_schedule.off, this.projectTimezone, 'HH:mm');
        }
      }
    },
    /**
     * The device row is the single source of truth for the operation state: this page and
     * every tab under it read it through Utils.getOperationStateValue, and nothing keeps a
     * second copy in component state.
     *
     * So every value that arrives from elsewhere has to land here. Retrofit actions
     * already do it themselves (retrofitActions' setOperationState -> editDeviceField,
     * which uses Vue.set, so even a first-time key is reactive and the badge recomputes);
     * this is the entry point for the header fetch, the tabs' lazy property reads, and
     * manual state changes.
     */
    syncOperationStateToStore(value){
      const device_id = this.device && this.device.id;
      if (!device_id || !value) return;

      this.$store.commit('Reports/editDeviceField', {
        device_id,
        name: 'cabinet.operation_state',
        value: cloneDeep(value)
      });
    },
    setElectricityPriceProp(prop){
      // Component-state-only field. Lazily provided by AdvancedTab.
      this.electricity_price_prop = prop || null;
    },
    updateScheduleData(){
      setTimeout(() => {
        this.setCurrentCabinetSchedule();
      }, 2000);
    },
    updateOperationState(new_operation_state){
      this.syncOperationStateToStore(new_operation_state);
      if (this.device) invalidateDeviceTabCache(this.device.id);
    },
    updateTariffData(new_tariff_data){
      this.electricity_price_prop = cloneDeep(new_tariff_data);
      if (this.device) invalidateDeviceTabCache(this.device.id);
    },
    setCabinetStreams(value){
      this.cabinetStreams = value;
    },
    setCabinetData() {
      const metaDevice = cloneDeep(this.device['meta.device']);
      this.cabinetData.id = metaDevice.cabinet_id || 'N/A';
      this.cabinetData.installation_date = this.device['meta.commission'].date;
      this.cabinetData.installater = this.device['meta.commission'].commissioner;
      this.cabinetData.address = metaDevice.cabinet_address || (metaDevice.estimated_address && `${metaDevice.estimated_address} (${this.$t('estimated')})`) || 'N/A';
      this.cabinetData.road = metaDevice.road || 'N/A';
      this.cabinetData.managed_area = metaDevice.managed_area || 'N/A';
      this.cabinetData.cabinet_type = Utils.hasVirtualCabinetClass(this.device['meta.category']) ? 'Virtual' : '';
      this.cabinetData.assigned_devices = metaDevice.hasOwnProperty('assigned_devices') && metaDevice.assigned_devices ? metaDevice.assigned_devices : 0;
      this.cabinetData.controlled_devices = metaDevice.hasOwnProperty('controlled_devices') && metaDevice.controlled_devices ? metaDevice.controlled_devices : 0;
      this.cabinetData.actual_controlled_devices = this.cabinetDevices.length;
      this.cabinetData.total_poles = metaDevice.hasOwnProperty('total_poles') && metaDevice.total_poles ? metaDevice.total_poles : 0;
      this.cabinetData.controlled_poles = metaDevice.hasOwnProperty('controlled_poles') && metaDevice.controlled_poles ? metaDevice.controlled_poles : 0;
      this.cabinetData.actual_controlled_poles = this.getPolesCount();
      this.cabinetData.uncommunicated_count = this.cabinetDevices.filter((device) => device.sys___active === -3).length;
      this.cabinetData.communicated_count = this.cabinetData.actual_controlled_devices - this.cabinetData.uncommunicated_count;
      this.cabinetData.description = metaDevice.hasOwnProperty('description') && metaDevice.description || '';
      this.setCabinetServiceIsOn();
      this.setCabinetTabs();
      this.setConnectedAndActive();
    },
    setConnectedAndActive(){
      if (!this.device) return;
      const controlled_fixtures = this.$store.getters['Reports/cabinets_fixtures'].get(this.device.id) || [];
      // Only fixtures genuinely under Retrofit / Partial Retrofit are excluded
      // from the percentage - an info icon next to it explains how many were
      // excluded and why. Utils.isDeviceLive is deliberately NOT used here: it
      // also reports pending-verification devices (returned from Retrofit,
      // waiting to reconnect) as not-live, which would count them as Retrofit
      // in the tooltip even though they're already back in Delivered. This also
      // keeps the stat aligned with Cabinet Management, whose per-cabinet counts
      // exclude retrofit fixtures only.
      const counted_fixtures = controlled_fixtures.filter((device) => {
        const operation_state = Utils.getOperationState(device);
        return operation_state !== RETROFIT_STATE && operation_state !== PARTIAL_RETROFIT_STATE;
      });
      this.cabinetData.retrofit_fixtures_count = controlled_fixtures.length - counted_fixtures.length;
      this.cabinetData.controlled_fixtures_count = counted_fixtures.length;
      this.cabinetData.connected_fixtures_percentage = this.cabinetData.controlled_fixtures_count 
        ? Math.floor((this.getConnectedPercentage(counted_fixtures) / this.cabinetData.controlled_fixtures_count) * 100)
        : 0;
    },
    setActualControlledPoles(){
      this.cabinetData.actual_controlled_poles = this.getPolesCount();
    },
    setActualControlledFixtures(){
      this.cabinetData.actual_controlled_devices = this.cabinetDevices.length;
    },
    setCommunicationData(){
      this.cabinetData.uncommunicated_count = this.cabinetDevices.filter((device) => device.sys___active === -3).length;
      this.cabinetData.communicated_count = this.cabinetData.actual_controlled_devices - this.cabinetData.uncommunicated_count;
    },
    getConnectedPercentage(controlled_devices){
      return controlled_devices.filter((device) => device.sys___active === 1 && device.sys___connected === 1).length;
    },
    setCabinetTabs(){
      let final_tabs = this.cabinetData.cabinet_type 
        ? this.all_tabs.filter((tab) => tab.virtual)
        : this.all_tabs.filter((tab) => tab.regular);
      if (this.readonly_user) {
        final_tabs = final_tabs.filter((tab) => tab.readonly);
      }

      this.tabs = final_tabs;
    },
    setCabinetServiceIsOn(){
      this.services_config = this.device['services.config'];
      const alert_config = this.services_config.hasOwnProperty('alerts') ? this.services_config.alerts : {};
      const schedule_config = this.services_config.hasOwnProperty('schedule_validation') ? this.services_config.schedule_validation : {};
      let alert_is_on = true, schedule_is_on = false;

      if (schedule_config.hasOwnProperty('kill_switch')) {
        this.services_config_status.display_schedule_service = true;
        if (schedule_config.kill_switch === false) schedule_is_on = true;
      }

      if (Object.keys(alert_config).length){
        this.services_config_status.display_alerts_service = true;
        this.services_config_status.display_cabinet_iq_service = true && !this.cabinetData.cabinet_type;

        if (!alert_config.hasOwnProperty('kill_switch_analytics_alerts')) {
          alert_config.kill_switch_analytics_alerts = false;
        }
        if (!alert_config.hasOwnProperty('kill_switch_cabinet_alerts')) {
          alert_config.kill_switch_cabinet_alerts = false;
        }

        const window = this.getAlertsWindowByTimestamp(alert_config.window);
        if (window){
          // alert_on_window = +localStorage.getItem('now') > window.end && +localStorage.getItem('now') < window.start ? false : true;
          this.setAlertsWindowByTimezone(window);
          this.setAlertsTimeRange(alert_config.window);
        }
        if (alert_config.kill_switch_analytics_alerts === true) {
          alert_is_on = false;
        }
      }

      this.services_config_status.alert_is_on = alert_is_on;
      this.services_config_status.schedule_is_on = schedule_is_on;
      this.services_config_status.enabled_turn_off = this.isManager || this.userRole === 'CA' || this.userRole === 'CM';
      this.services_config_status.cabinet_iq_is_on = !alert_config.kill_switch_cabinet_alerts;
    },
    getAlertsWindowByTimestamp(window){
      if (window && Object.keys(window).length && window.start && window.end) {
        const alert_window = {...window};
        alert_window.start = Utils.getDateWithSpecificTime(window.start, +localStorage.getItem('now'));
        alert_window.end = Utils.getDateWithSpecificTime(window.end, +localStorage.getItem('now'));
        return alert_window;
      }
      return null;
    },
    setAlertsWindowByTimezone(window){
      const start_by_timezone = Utils.convertTimestamp(window.start, 'HH:mm', this.projectTimezone);
      const end_by_timezone = Utils.convertTimestamp(window.end, 'HH:mm', this.projectTimezone);
      this.services_config_status.window = {start: start_by_timezone, end: end_by_timezone};
    },
    setAlertsTimeRange(window){
      const [start_hours, start_minutes] = window.start.split(':');
      const [end_hours, end_minutes] = window.end.split(':');
      const start_timestamp = moment().utcOffset(0).set({hour: +start_hours, minute: +start_minutes}).valueOf();
      const end_yesterdat_timestamp = moment().utcOffset(0).subtract(1, 'days').set({hour: +end_hours, minute: +end_minutes}).valueOf();
      const end_timestamp = moment().utcOffset(0).set({hour: +end_hours, minute: +end_minutes}).valueOf();
      
      const difference1 = Math.abs(start_timestamp - end_yesterdat_timestamp);
      const difference2 = Math.abs(start_timestamp - end_timestamp);
      if (difference1 > 40 * 60000 && difference2 > 40 * 60000){ // convert 40 minutes to milliseconds
        this.services_config_status.partial_day = true;
      }else {
        this.services_config_status.partial_day = false;
      }
    },
    getPolesCount() {
      const poles_and_circuits = this.cabinetDevices.filter((device) => {
        const meta_device = this.$store.getters['Reports/commissioned_map'].get(device.id)['meta.device'];
        return meta_device.pole_number && meta_device.circuit_number;
      });
      const poles_by_circuit = poles_and_circuits.reduce((acc, curr) => {
        const circuit_number = this.$store.getters['Reports/commissioned_map'].get(curr.id)['meta.device'].circuit_number.toString();
        const pole_number = this.$store.getters['Reports/commissioned_map'].get(curr.id)['meta.device'].pole_number.toString();
        acc[circuit_number] 
          ? acc[circuit_number].add(pole_number) 
          : acc[circuit_number] = new Set([pole_number]);
        return acc;
      }, {});
      const poles = new Set();
      this.cabinetDevices.filter((device) => !poles_and_circuits.includes(device)).forEach((device) => {
        const pole_number = this.$store.getters['Reports/commissioned_map'].get(device.id)['meta.device'].pole_number;
        if (pole_number && !poles.has(pole_number) && !Object.values(poles_by_circuit).some((set) => set.has(pole_number))) poles.add(pole_number);
      });
      const count_by_circuit = Object.values(poles_by_circuit).reduce((acc, curr) => acc + curr['size'], 0);
      return poles.size + Number(count_by_circuit);
    },
    goBack(){
      this.project.company === 'allProjects'
        ? this.$router.push(`/${this.$route.params.location}/alerts/${this.$route.params.pid}`)
        : this.$router.go(-1);
    },
    setSelectedTab(tabName) {
      this.selectedTab = tabName;
    },
    getStreamStatus(stream) {
      return this.device && this.device[stream]
        ? require('@/assets/images/cluster_icons/green-square-rounded-24.png')
        : require('@/assets/images/cluster_icons/red-square-rounded-24.png');
    },
    getLastActivity(sys_active_modified) {
      const sys_active_modified_utc = moment.utc(sys_active_modified * 1000).format();
      return moment.tz(sys_active_modified_utc, this.$store.state.Global.timezone).format('DD.MM.YYYY HH:mm');
    },
    setPhasesLiveData(live_data) {
      this.phasesLiveData = cloneDeep(live_data);
    },
    updateMetaDeviceFields(meta_device){
      // Cross-page write-back: store row is the source of truth, so commit
      // there. The reactive `device` getter re-emits and setCabinetData()
      // re-renders this page. MapView/Inventory/AlertManagement also pick
      // up the new meta.device on their next render.
      this.$store.commit('Reports/setDeviceField', {
        device_id: this.device.id,
        field: 'meta.device',
        value: { ...meta_device }
      });
      this.$store.commit('Reports/recomputeIconForDevice', this.device.id);
      this.setCabinetData();
    },
    updateServiceStatus(service_type, services_status){
      this.services_config_status = {...services_status};
      const services_property = {
          name: 'services.config',
          objectID: this.device.id,
          objectType: Types.DEVICES
      };

      if (service_type === 'alerts'){
        this.services_config.alerts.kill_switch_analytics_alerts = !this.services_config_status.alert_is_on;
      }else if (service_type === 'schedules'){
        this.services_config.schedule_validation.kill_switch = !this.services_config_status.schedule_is_on;
        if (this.services_config.schedule_validation.kill_switch) {
          let last_change = moment().utcOffset(0).valueOf(); // milliseconds
          last_change = Math.floor(last_change / 1000); // seconds
          this.services_config.schedule_validation.last_change = last_change;
        }
      }else if (service_type === 'cabinet_iq'){
        this.services_config.alerts.kill_switch_cabinet_alerts = !this.services_config_status.cabinet_iq_is_on;
      }
      
      this.$refs.propEditor.save(
          this.services_config,
          services_property,
          () => {
            // Cross-page write-back. setDeviceField guards against no-op writes
            // and triggers icon recompute when relevant.
            this.$store.commit('Reports/setDeviceField', {
              device_id: this.device.id,
              field: 'services.config',
              value: cloneDeep(this.services_config)
            });
          },
          `Service Status has been successfully updated`
      );
    },
    setCabinetAlertsList(){
      this.alerts_list = [];
      this.incidents_data.low = 0;
      this.incidents_data.mid = 0;
      this.incidents_data.high = 0;

      if (!this.projectAlerts || !this.projectAlerts.length) return;
      if (!this.device) return;

      const cabinet_id = this.device['meta.device'].cabinet_id;
      const cabinet_alerts = this.projectAlerts.filter((incident) => incident.cabinet_id === cabinet_id);
      if (!cabinet_alerts.length) return;

      const high_priority = cabinet_alerts.filter((alert) => alert.priority === 3).sort((a, b) => a.time - b.time);
      const mid_priority = cabinet_alerts.filter((alert) => alert.priority === 2).sort((a, b) => a.time - b.time);
      const low_priority = cabinet_alerts.filter((alert) => alert.priority === 1).sort((a, b) => a.time - b.time);
      this.alerts_list = cloneDeep([...high_priority, ...mid_priority, ...low_priority]);
      this.incidents_data.high = high_priority.length;
      this.incidents_data.mid = mid_priority.length;
      this.incidents_data.low = low_priority.length;
    },
    updateServicesConfig(new_config){
      this.services_config = cloneDeep(new_config);
      // Mirror cross-page write-back for changes that originated from inside
      // tab components (Advanced → max daily consumption, etc.).
      if (this.device) {
        this.$store.commit('Reports/setDeviceField', {
          device_id: this.device.id,
          field: 'services.config',
          value: cloneDeep(new_config)
        });
        invalidateDeviceTabCache(this.device.id);
      }
    },
    setCabinetEventsList(){
      this.events_list = [];

      if (!this.projectEvents || !this.projectEvents.length) return;
      if (!this.device || !this.device['meta.device']) return;

      const cabinet_id = this.device['meta.device'].cabinet_id;
      const cabinet_events = this.projectEvents.filter((event) => event.cabinet_id === cabinet_id);
      if (!cabinet_events.length) return;

      this.events_list = cloneDeep(cabinet_events);
    }
  },
  computed: {
    retrofitTooltipText() {
      return `${this.cabinetData.retrofit_fixtures_count} ${this.$t('devices in Retrofit state are excluded from this percentage')}`;
    },
    time_window() {
      return this.lang === 'en' ? `${this.services_config_status.window.start} - ${this.services_config_status.window.end}` : `בין השעות ${this.services_config_status.window.end} - ${this.services_config_status.window.start}`;
    },
    connection_state(){
      const modified_text = this.sys___connected_modified ? `${this.$t('since')} ${this.sys___connected_modified}` : '';
      return this.sys___connected_modified !== undefined && this.sys___connected_modified !== null
        ? this.device.sys___connected
            ? `${this.$t('Connected')} ${modified_text}`
            : `${this.$t('Disconnected')} ${modified_text}`
        : this.$t('N/A');
    },
    // The one place this page reads the operation state from. Everything that produces a
    // value writes it to the device row (see syncOperationStateToStore), so there is no
    // second copy to rank against this one - which is what went wrong when Retrofit
    // started backdating `date` and the ranking picked the superseded value.
    operation_state_value() {
      return Utils.getOperationStateValue(this.device);
    },
    cabinet_in_retrofit(){
      const state_value = this.operation_state_value;
      return !!state_value && state_value.cabinet_opstate === RETROFIT_STATE;
    },
    // The cabinet's real connectivity isn't meaningful while it's out for
    // Retrofit, so the Connected/Disconnected chip is dropped from the header
    // (same rule as the connectivity rows in the Advanced tab).
    display_connection_state(){
      return !this.cabinetData.cabinet_type && !this.cabinet_in_retrofit;
    },
    operation_state(){
      const state_value = this.operation_state_value;
      const date = state_value
        ? state_value.cabinet_opstate === 'installing' || !state_value.date
          ? null
          : Utils.convertTimestamp(state_value.date * 1000, 'DD/MM/YYYY HH:mm', this.projectTimezone)
          : null;

      if (!state_value) return '';

      const cabinet_opstate = state_value.cabinet_opstate;

      if (cabinet_opstate === 'installing') return this.$t('Installing');

      // Pending Verification deliberately does NOT appear here: it's a connectivity state
      // (sys___active === -4), not an operation state. The operation states are
      // installing / delivered / retrofit, plus partial_retrofit for cabinets, and
      // `delivered` reads as Operational - matching the Advanced tab's selector.
      if (cabinet_opstate === DELIVERED_STATE) {
        return date ? `${this.$t('Operational since')} ${date}` : this.$t('Operational');
      }

      if (cabinet_opstate === RETROFIT_STATE) {
        return date ? `${this.$t('Retrofit since')} ${date}` : this.$t('Retrofit');
      }

      if (cabinet_opstate === PARTIAL_RETROFIT_STATE) {
        return date ? `${this.$t('Partial Retrofit since')} ${date}` : this.$t('Partial Retrofit');
      }

      return '';
    },
    // `operation_state` is a translated sentence, so the badge takes its colour from the
    // raw state instead of trying to read the label back. Installing is the only other
    // state, and it stays neutral.
    operation_state_badge_class(){
      const state_value = this.operation_state_value;
      const cabinet_opstate = state_value && state_value.cabinet_opstate;

      if (cabinet_opstate === RETROFIT_STATE || cabinet_opstate === PARTIAL_RETROFIT_STATE) {
        return 'operation-state-badge--retrofit';
      }

      if (cabinet_opstate === DELIVERED_STATE) {
        return 'operation-state-badge--operational';
      }

      return 'operation-state-badge--neutral';
    },
    readonly_user(){
      return this.$store.state.Global.readonly_user;
    },
    lang(){
      return this.$store.state.Global.lang;
    },
    getAlertServiceStatus() {
      return this.services_config_status.alert_is_on
        ? require('@/assets/images/cluster_icons/green-square-rounded-24.png')
        : require('@/assets/images/cluster_icons/grey-square-rounded-24.png');
    },
    getCabinetAlertServiceStatus() {
      return this.services_config_status.cabinet_iq_is_on
        ? require('@/assets/images/cluster_icons/green-square-rounded-24.png')
        : require('@/assets/images/cluster_icons/grey-square-rounded-24.png');
    },
    getCabinetScheduleStatus() {
      return this.schedule_service.active
        ? require('@/assets/images/cluster_icons/green-square-rounded-24.png')
        : require('@/assets/images/cluster_icons/grey-square-rounded-24.png');
    },
    getGeoLocation() {
      return Utils.deviceLocation(this.device);
    },
    projectDevices() {
      return this.$store.state.Reports.reportsList;
    },
    project() {
      return this.$store.state.User.project;
    },
    projectProperties() {
      return this.$store.state.Props.list;
    },
    projectTimezone() {
      return this.$store.state.Global.timezone || this.$store.state.Global.allProjectsTimezone || 'Asia/Tel_Aviv';
    },
    isManager(){
      return this.$store.state.User.isManager;
    },
    userRole(){
      return this.$store.state.User.role;
    },
    // devicesOn(){
    //   return this.lang === 'en' 
    //     ? `${this.cabinetDevices.filter((device) => device.power > 0).length} / ${this.cabinetDevices.length}`
    //     : `${this.cabinetDevices.length} / ${this.cabinetDevices.filter((device) => device.power > 0).length}`;
    // },
    device() {
      // Reactive read — any MQTT update, save, fixture-tab edit, or other
      // page's mutation flows through to this page automatically.
      const id = this.$route.params.id || this.$route.params.cid || '';
      return this.$store.getters['Reports/cabinet_by_id'](id);
    },
    cabinetDevices() {
      // Reactive read via cabinets_fixtures getter (Map keyed by cabinet device id).
      if (!this.device) return [];
      const fixtures_map = this.$store.getters['Reports/cabinets_fixtures'];
      return fixtures_map.get(this.device.id) || [];
    },
    // cabinets_fixtures never reads pole.operation_state while building its Map,
    // so the array reference it returns doesn't change when a fixture's retrofit
    // state flips in place - the `cabinetDevices` watcher below would silently miss
    // it. Reading the raw operation state (+ sys___active) per fixture here (now
    // that Reports/editDeviceField uses Vue.set) makes this computed track those
    // exact properties directly, so it recomputes on every retrofit mark/return -
    // even from a batch run on this same page (FullViewTab's embedded map).
    // The raw state is used rather than Utils.isDeviceLive because a
    // retrofit -> pending-verification transition leaves isDeviceLive false on
    // both sides, which would make this signature miss the change entirely.
    fixturesLiveSignature() {
      return this.cabinetDevices
        .map((device) => `${Utils.getOperationState(device)}:${device.sys___active}`)
        .join('|');
    },
    // Same property-level tracking trick as fixturesLiveSignature: marking the
    // cabinet as Retrofit turns the 3 services off by writing services.config
    // straight to the store, which never changes the `device` object reference,
    // so the `device` watcher (and with it setCabinetServiceIsOn) would miss it.
    servicesConfigSignature() {
      const config = this.device && this.device['services.config'];
      if (!config) return '';
      const alerts = config.alerts || {};
      const schedule_validation = config.schedule_validation || {};
      return [
        alerts.kill_switch_analytics_alerts,
        alerts.kill_switch_cabinet_alerts,
        schedule_validation.kill_switch
      ].join('|');
    },
    projectAlerts(){
      return this.$store.state.Projects.projectAlerts;
    },
    projectEvents(){
      return this.$store.state.Projects.projectEvents;
    },
    devices_count(){
      return this.$store.state.Reports.devicesCount;
    },
    dusk_dawn_data() {
      return this.$store.state.Global.dusk_dawn_data;
    },
    // `schedule_service` is an imperatively-filled snapshot, so the header chip
    // has to be re-derived whenever the store row's schedule changes - the
    // schedule is deactivated outside this page's flow (marking the cabinet as
    // Retrofit mirrors `active: false` onto the row via Reports/editDeviceField).
    cabinetScheduleSignature(){
      const schedule = this.device && this.device['meta.devices_schedule'];
      if (!schedule || typeof schedule !== 'object') return '';
      return [
        schedule.active,
        schedule.is_astronomical,
        schedule.on,
        schedule.off,
        schedule.dusk,
        schedule.dawn,
        schedule.updater
      ].join('|');
    }
  },
  watch: {
    device(newDevice, oldDevice){
      // First time the row appears in the store — derive cabinetData,
      // schedule and incidents.
      if (newDevice && !oldDevice) {
        this.setCabinetData();
        this.setCurrentCabinetSchedule();
        this.setIncidentsData();
      } else if (newDevice) {
        // Subsequent updates (MQTT / saves) — keep cabinetData in sync.
        this.setCabinetData();
      }
    },
    cabinetDevices(){
      // Live updates: keep counts and incidents in sync whenever this
      // cabinet's fixture set changes (MQTT delta, late-arriving stream
      // batch, in-page edit, etc.).
      this.setConnectedAndActive();
      this.setActualControlledPoles();
      this.setActualControlledFixtures();
      this.setCommunicationData();
      if (this.device) {
        this.incidents_data.devices = this.$store.getters['Reports/cabinets_fixtures'].get(this.device.id);
      }
    },
    // Catches retrofit mark/return on this cabinet's fixtures even when
    // `cabinetDevices` itself doesn't fire (see fixturesLiveSignature above).
    fixturesLiveSignature() {
      this.setConnectedAndActive();
    },
    cabinetScheduleSignature() {
      this.setCurrentCabinetSchedule();
    },
    // Re-derives the header icons / Advanced tab switches after the services are
    // turned off by marking this cabinet as Retrofit.
    servicesConfigSignature() {
      if (this.device && this.device['services.config']) this.setCabinetServiceIsOn();
    },
    projectAlerts(){
      this.setCabinetAlertsList();
    },
    projectEvents(){
      this.setCabinetEventsList();
    }
  }
};
</script>

<style scoped>
/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #292f7d;
  border-radius: 5px;
}

.title {
  font-family: 'Open Sans', 'Arial', monospace !important;
}

.section-title {
  color: #0b1146;
}

.cabinet-details-screen {
  background-color: #f2f4f8;
}

.tabs-cabinet-details {
  z-index: 1;
  border-radius: 12px;
  border: 1px solid #332a8f !important;
}

.tab-cabinet-details {
  padding: 6px 8px 6px 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: center;
  display: inline-block;
  height: 100%;
  justify-content: center;
  align-content: center;
  color: #332a8f;
}

.selected-tab-cabinet-details {
  border-radius: 12px;
  background-color: #332a8f;
  color: #fff !important;
}

.overflow-style {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.overflow-style:hover {
  overflow: visible;
}

.overflow-style:hover span {
  position: relative;
  background-color: white;
  box-shadow: 0 0 4px 0 black;
  border-radius: 5px;
}

.property-name {
  color: #6a6a6a;
}

/* Status badge at the end of the cabinet name row. It's the first thing the page should
   convey, so it's deliberately larger than the surrounding body text. inline-flex keeps
   the icon on the text's baseline row, since v-img is a block element and would
   otherwise sit above it. */
.operation-state-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 16px;
  border: 1px solid transparent;
  border-radius: 18px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
}

/* Scoped styles reach a child component's root element, which is what .v-image is.
   Without this the image flexes to fill the badge instead of staying 18px. */
.operation-state-badge .v-image {
  flex: 0 0 18px;
}

/* From xl up the header card splits into columns (the v-flex above is xs12 xl5), so the
   badge - the last item in the name row, pushed out by the v-spacer - ends up flush
   against the neighbouring column. Below xl it owns the full row width and needs no gap.
   1904px is Vuetify 1.5's xl breakpoint, the same one xl5 switches on, and 1.5 has no
   breakpoint-scoped spacing helpers to express this in the template. */
@media only screen and (min-width: 1904px) {
  .operation-state-badge--gap-ltr {
    margin-right: 24px;
  }

  .operation-state-badge--gap-rtl {
    margin-left: 24px;
  }
}

.operation-state-badge--retrofit {
  background-color: #fdf1e1;
  border-color: #efd7b4;
  color: #8a6d3b;
}

.operation-state-badge--operational {
  background-color: #eef7ef;
  border-color: #c9e3cb;
  color: #2e7d32;
}

.operation-state-badge--neutral {
  background-color: #f5f6fb;
  border-color: #dcdfee;
  color: #656b8c;
}

.status-div-square {
  width: 20px;
  height: 20px;
}

.green-background {
  background-color: #91e15d;
}

.grey-background {
  background-color: #6598ae;
}
</style>
